import axios from 'axios';
import router from '../router';
import { Module } from "vuex";


const Auth: Module<any, any> = {
    state: {
        token: localStorage.getItem("token") || '',
        user: {},
        status: ''
    },
    //@ts-ignore
    mutations: {
        auth_request(state: any){
            state.status = 'loading';
        },
        // auth_success(state: any, token: string, user: any) {
        //     state.token = token;
        //     state.user = user;
        //     state.status = 'success';
        // },
        registration_request(state: any){
            state.status = 'loading'
        },
        registration_success(state: any){
            state.status = 'success';
        },
        logout(state: any){
            state.token = '';
            state.user = {};
            state.status = '';
        },
        profile_request(state: any){
            state.status = 'loading';
        },
        user_profile(state: any, user: any){
            state.user = user;
            state.status = 'success';
        }
    },
    actions: {
        //Login Action
        async login({ commit }, user){
            commit('auth_request');
            let res = await axios.post('http://localhost:5000/api/users/login', user);
            if(res.data.success){
                const token = res.data.token;
                const user = res.data.user;
                // Store the token into the localstorage
                localStorage.setItem('token', token);
                // Set the axios default
                axios.defaults.headers.common['Authorization'] = token;
                commit('auth_success', token, user);
            }
            return res;
        },
        //Register user
        async registration({commit}, registration){
            commit('registration_request');
            let res = await axios.post('http://localhost:5000/api/users/registration', registration);
            if(res.data.success !== undefined){
                commit('registration_success');
            }
            return res;
        },
        async getProfile({commit}){
          commit('profile_request');
          let res = await axios.get('http://localhost:5000/api/users/profile');
          commit('user_profile', res.data.user);
          return res;
        },
        //Logout the user
        async logout({commit}){
            await localStorage.removeItem('token');
            commit('logout');
            delete axios.defaults.headers.common['Authorization'];
            router.push({name : 'home'});
            return
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authState: state => state.status,
        user: state => state.user
    },
};

export default Auth;
